import { render, staticRenderFns } from "./ImageColorProperties.vue?vue&type=template&id=66c5f8ae"
import script from "./ImageColorProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageColorProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports